import * as React from 'react';
import { Select } from 'antd';
import _ from 'lodash';
import { observer } from 'mobx-react';
export const Materials = observer((props) => {
    const manufacturing_type = props?.manufacturing_type;
    let items = props.materials;
    if (manufacturing_type) {
        items = items.filter(item => {
            return item.manufacturing_types.some(type => type.toLowerCase() === manufacturing_type.toLowerCase());
        });
    }
    const materials_grouped = _.groupBy(items, (item) => item.material_type);
    const menu = _.map(materials_grouped, (items, key) => {
        const label = key !== 'null' ? key : 'Uncategorized';
        return (React.createElement(Select.OptGroup, { key: key, label: label }, items.map(material => (React.createElement(Select.Option, { key: material.id }, material.name)))));
    });
    const EmptyTag = (React.createElement("div", { className: "flex flex-no-wrap p-2 cursor-pointer", onClick: () => {
            const custom = items.find(item => item.name === 'Custom');
            if (custom && props.onChange) {
                props.onChange({
                    key: custom.id.toString(),
                    label: custom.name,
                }, []);
            }
        } },
        React.createElement("span", { className: "flex flex-row items-center cursor-pointer justify-center" },
            "Can't find your material? please select ",
            React.createElement("div", { className: "ml-2 link" }, "Custom"))));
    return (React.createElement("div", null,
        React.createElement(Select, { showSearch: true, labelInValue: true, size: 'small', placeholder: "Select", allowClear: true, filterOption: (input, option) => {
                try {
                    if (!option.key) {
                        // Filter by group label
                        return option.props?.label?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0;
                    }
                    return option.props?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0;
                }
                catch (e) {
                    return false;
                }
            }, notFoundContent: EmptyTag, dropdownMatchSelectWidth: false, style: { width: '100%' }, ...props, dropdownRender: menu => menu }, menu)));
});
